import React, { Component } from 'react';
import avatar from '../avatar.png'
import Leftbar from '../components/Leftbar'; 

class Contact extends Component {
    render() {
        return (
            <>
              <Leftbar />  
              <div className="container min-100">
                  <div className="row main-section justify-content-md-center align-items-center">
                      <div className="col photo-col">
                          <img src={avatar} className="avatar-style" alt="contacto-img" />
                      </div>
                      <div className="col">
                            <h2>Contact</h2>
                            <p>If you want to know more about me or my work, or if you just like to say hello, send me a message I'd love to hear from you.</p>
                            <p>Send me a Hi! <a href="mailto:jesus.cortes.code@gmail.com">jesus.cortes.code@gmail.com</a></p>
                      </div>
                  </div>
              </div>
            </>
        );
    }
}

export default Contact;